module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARFJREFUWEftlr1LQzEUxc+JgyBuXd7Y11UQXB3qJig4CM21s672r9FV55oMDoKDm4KuguAmpuNb3ERwMFfsVF5j1wgmY+6595788kGIzIOZ+6MYKAQKgUKgEJgSCNZWasy2qnYM0HyoXq15/77omX4V6UN1faohn3rO3S3SP1u7ukLuRaAi+cYYb2rvG74MBjtLxlwCWJ4p0NCY3e54/JgqGkTOABy2Yue1c0cp/WQ43NAYrwFUM/HPrxj3Gay9B7mZSHS1cwft+Z+VE7hNNVJgK0UiiFwAkLkc1QcGEf0F3aR2rp4zYO0xyZOkAdVRz/vTdiyIBADdVM4fMJB7C7IfwuzXsHzJCoFCoBAoBP49gW9VfqNrvToqeAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/other-contract-red.png
// module id = c/7j
// module chunks = 41